module.exports = __webpack_public_path__ + "img/duopingtai_guanlihoutai.5c787bfc.png";